import {Typography} from "@material-tailwind/react";
import persianNumberFormat from "../../../helper/PersianNumberFormat";
import React, {useState} from "react";
import {TableHead} from "../../system/thead";


const TABLE_HEAD = ["#", "رزرو", "مشاوره", "استعلام قیمت", "خدمات", "سرویس جدید", "سرویس", "تاریخ"];

export function DailyWorkReportGrid({
                                      dailyWorkReport,
                                      setSortBy,
                                      sortType,
                                      setSortType
                                    }) {

  const [selectedHead, setSelectedHead] = useState("#")

  const headMap = {
    "#": "",
    "رزرو": "new_reservation",
    "مشاوره": "finished_reservation",
    "استعلام قیمت": "new_service",
    "خدمات": "finished_service",
    "سرویس جدید": "new_work",
    "سرویس": "finished_work",
    "تاریخ": "date",
  }

  const headSortable = {
    "#": false,
    "رزرو": true,
    "مشاوره": true,
    "استعلام قیمت": true,
    "خدمات": true,
    "سرویس جدید": true,
    "سرویس": true,
    "تاریخ": true,
  }

  return (
    <div className="w-full">
      <table className="mt-4 w-full">
        <TableHead
          tableHead={TABLE_HEAD}
          headSortable={headSortable}
          headMap={headMap}
          sortType={sortType}
          setSortType={setSortType}
          setSortBy={setSortBy}
          selectedHead={selectedHead}
          setSelectedHead={setSelectedHead}
        />
        <tbody className="w-full textCenter">
        {dailyWorkReport?.map(
          ({
             new_reservation,
             finished_reservation,
             new_service,
             finished_service,
             new_work,
             finished_work,
             date,
           }, index) => {
            const isLast = index === dailyWorkReport.length - 1;
            const classes = isLast ? "p-4" : "p-4 border-b border-blue-gray-50";

            return (
              <tr key={date}>

                <td className={classes}>
                  <div className="flex justify-center">
                    <Typography color="blue-gray">
                      {persianNumberFormat(index + 1, true)}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex flex-col justify-center px-4">
                    <Typography color="blue-gray">
                      {persianNumberFormat(new_reservation, true)}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex flex-col justify-center px-4">
                    <Typography color="blue-gray">
                      {persianNumberFormat(finished_reservation, true)}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex flex-col justify-center px-4">
                    <Typography color="blue-gray">
                      {persianNumberFormat(new_service, true)}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex flex-col justify-center px-4">
                    <Typography color="blue-gray">
                      {persianNumberFormat(finished_service, true)}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex flex-col justify-center px-4">
                    <Typography color="blue-gray">
                      {persianNumberFormat(new_work, true)}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex flex-col justify-center px-4">
                    <Typography color="blue-gray">
                      {persianNumberFormat(finished_work, true)}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex flex-col justify-center px-4">
                    <Typography color="blue-gray">
                      {persianNumberFormat(date)}
                    </Typography>
                  </div>
                </td>

              </tr>
            );
          },
        )}
        </tbody>
      </table>
    </div>
  );
}